/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["prbJsonp"];
/******/ 	window["prbJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		7: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		if(installedChunks[chunkId] === 0) {
/******/ 			return Promise.resolve();
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunks[chunkId]) {
/******/ 			return installedChunks[chunkId][2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunks[chunkId][2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "js/" + ({"0":"site","1":"article","2":"homepage","3":"archive","4":"editor","5":"styleguide","6":"print"}[chunkId]||chunkId) + ".46d7bf5.chunk.min.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/wp-content/themes/prb-2017/static/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/ })
/************************************************************************/
/******/ ({

/***/ "./client/images/icon-arrow-expand-all-blue.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdGFiaW5kZXg9Ii0xIj4KCTxwYXRoIGZpbGw9IiMwMDQ2N0YiIGQ9Ik05LjUgMTMuMDlsMS40MSAxLjQxLTQuNSA0LjVIMTB2Mkgzdi03aDJ2My41OWw0LjUtNC41bTEuNDEtMy41OUw5LjUgMTAuOTEgNSA2LjQxVjEwSDNWM2g3djJINi40MWw0LjUgNC41bTMuNTkgMy41OWw0LjUgNC41VjE0aDJ2N2gtN3YtMmgzLjU5bC00LjUtNC41IDEuNDEtMS40MU0xMy4wOSA5LjVsNC41LTQuNUgxNFYzaDd2N2gtMlY2LjQxbC00LjUgNC41LTEuNDEtMS40MXoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "./client/images/icon-arrow-expand-all-white.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdGFiaW5kZXg9Ii0xIj4KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik05LjUgMTMuMDlsMS40MSAxLjQxLTQuNSA0LjVIMTB2Mkgzdi03aDJ2My41OWw0LjUtNC41bTEuNDEtMy41OUw5LjUgMTAuOTEgNSA2LjQxVjEwSDNWM2g3djJINi40MWw0LjUgNC41bTMuNTkgMy41OWw0LjUgNC41VjE0aDJ2N2gtN3YtMmgzLjU5bC00LjUtNC41IDEuNDEtMS40MU0xMy4wOSA5LjVsNC41LTQuNUgxNFYzaDd2N2gtMlY2LjQxbC00LjUgNC41LTEuNDEtMS40MXoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "./client/js/utilities/SmoothScroll.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Network component for handling smooth scrolling
 */
var SmoothScroll = function () {

  /**
   * Contstructor
   * @param {object} pointerSelector - selector that will trigger scroll
   */
  function SmoothScroll(pointerSelector) {
    _classCallCheck(this, SmoothScroll);

    this.pointerSelector = pointerSelector;
  }

  /**
   * Set Smooth Scrolling
   * @todo: consider updating this to not use jQuery
   */


  _createClass(SmoothScroll, [{
    key: 'init',
    value: function init() {
      $('body').on('click', this.pointerSelector, function (e) {
        var hash = $(e.currentTarget).attr('href');

        if (/^#/.test(hash)) {
          e.preventDefault();
          var $target = $(hash);
          var $headerHeight = $('.site-nav').height() + 40; // w/ added padding

          $('html, body').stop().animate({
            scrollTop: $target.offset().top - $headerHeight
          }, 1000);
        }
      });
    }
  }]);

  return SmoothScroll;
}();

exports.default = SmoothScroll;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),

/***/ "./client/js/utilities/Throttle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function raf(cb) {
  return setTimeout(cb, 16);
};

/**
 * Network component for handling throttling of events via requestAnimationFrame
 */

var Throttle = function () {

  /**
   * Contstructor
   * @param {function} callback - function to debounce
   * @param {string} event - event on which the throttle should be applied
   * @param {HTMLElement} element - element on which throttle should be applied
   * @param {int} frequency - maximum frequency at which callback should be executed
   */
  function Throttle(callback, event, element) {
    var frequency = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 250;

    _classCallCheck(this, Throttle);

    this.event = event;
    this.element = element;
    this.frequency = frequency;
    this.timeout = false;
    this.callback = callback;

    // Bound events
    this.requestTick = this.requestTick.bind(this);
    this.update = this.update.bind(this);

    if (!this.callback) {
      window.error('Throttle error: you must specify a callback.');
    } else {
      this.addHandler();
    }
  }

  _createClass(Throttle, [{
    key: 'addHandler',
    value: function addHandler() {
      this.element.addEventListener(this.event, this.requestTick);
    }

    /**
     * Dispatches the event to the supplied callback
     * @private
     */

  }, {
    key: 'update',
    value: function update() {
      this.callback();
      window.clearTimeout(this.timeout);
      this.timeout = false;
    }

    /**
     * Ensures events don't get stacked
     * @private
     */

  }, {
    key: 'requestTick',
    value: function requestTick() {
      var _this = this;

      if (!this.timeout) {
        this.timeout = window.setTimeout(function () {
          raf(function () {
            _this.update();
          });
        }, this.frequency);
      }
    }

    /**
     * Remove debouncer
     * @private
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this.element.removeEventListerer(this.event, this.requestTick);
    }
  }]);

  return Throttle;
}();

exports.default = Throttle;

/***/ }),

/***/ "./node_modules/core-js/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("./node_modules/core-js/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("./node_modules/core-js/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
var document = __webpack_require__("./node_modules/core-js/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/core-js/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "./node_modules/core-js/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/modules/_core.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("./node_modules/core-js/modules/_redefine.js");
var ctx = __webpack_require__("./node_modules/core-js/modules/_ctx.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "./node_modules/core-js/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/core-js/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/modules/_property-desc.js");
module.exports = __webpack_require__("./node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("./node_modules/core-js/modules/_descriptors.js") && !__webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("./node_modules/core-js/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("./node_modules/core-js/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("./node_modules/core-js/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/core-js/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/core-js/modules/_object-pie.js");
var toObject = __webpack_require__("./node_modules/core-js/modules/_to-object.js");
var IObject = __webpack_require__("./node_modules/core-js/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("./node_modules/core-js/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "./node_modules/core-js/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/core-js/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var toIObject = __webpack_require__("./node_modules/core-js/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("./node_modules/core-js/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("./node_modules/core-js/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("./node_modules/core-js/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "./node_modules/core-js/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/core-js/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("./node_modules/core-js/modules/_hide.js");
var has = __webpack_require__("./node_modules/core-js/modules/_has.js");
var SRC = __webpack_require__("./node_modules/core-js/modules/_uid.js")('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("./node_modules/core-js/modules/_core.js").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "./node_modules/core-js/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("./node_modules/core-js/modules/_shared.js")('keys');
var uid = __webpack_require__("./node_modules/core-js/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("./node_modules/core-js/modules/_iobject.js");
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("./node_modules/core-js/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("./node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("./node_modules/core-js/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/core-js/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "./node_modules/core-js/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("./node_modules/core-js/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("./node_modules/core-js/modules/_object-assign.js") });


/***/ }),

/***/ "./node_modules/css-loader/lib/css-base.js":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "./node_modules/fastdom/fastdom.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(function(win) {

/**
 * FastDom
 *
 * Eliminates layout thrashing
 * by batching DOM read/write
 * interactions.
 *
 * @author Wilson Page <wilsonpage@me.com>
 * @author Kornel Lesinski <kornel.lesinski@ft.com>
 */

'use strict';

/**
 * Mini logger
 *
 * @return {Function}
 */
var debug = 0 ? console.log.bind(console, '[fastdom]') : function() {};

/**
 * Normalized rAF
 *
 * @type {Function}
 */
var raf = win.requestAnimationFrame
  || win.webkitRequestAnimationFrame
  || win.mozRequestAnimationFrame
  || win.msRequestAnimationFrame
  || function(cb) { return setTimeout(cb, 16); };

/**
 * Initialize a `FastDom`.
 *
 * @constructor
 */
function FastDom() {
  var self = this;
  self.reads = [];
  self.writes = [];
  self.raf = raf.bind(win); // test hook
  debug('initialized', self);
}

FastDom.prototype = {
  constructor: FastDom,

  /**
   * Adds a job to the read batch and
   * schedules a new frame if need be.
   *
   * @param  {Function} fn
   * @param  {Object} ctx the context to be bound to `fn` (optional).
   * @public
   */
  measure: function(fn, ctx) {
    debug('measure');
    var task = !ctx ? fn : fn.bind(ctx);
    this.reads.push(task);
    scheduleFlush(this);
    return task;
  },

  /**
   * Adds a job to the
   * write batch and schedules
   * a new frame if need be.
   *
   * @param  {Function} fn
   * @param  {Object} ctx the context to be bound to `fn` (optional).
   * @public
   */
  mutate: function(fn, ctx) {
    debug('mutate');
    var task = !ctx ? fn : fn.bind(ctx);
    this.writes.push(task);
    scheduleFlush(this);
    return task;
  },

  /**
   * Clears a scheduled 'read' or 'write' task.
   *
   * @param {Object} task
   * @return {Boolean} success
   * @public
   */
  clear: function(task) {
    debug('clear', task);
    return remove(this.reads, task) || remove(this.writes, task);
  },

  /**
   * Extend this FastDom with some
   * custom functionality.
   *
   * Because fastdom must *always* be a
   * singleton, we're actually extending
   * the fastdom instance. This means tasks
   * scheduled by an extension still enter
   * fastdom's global task queue.
   *
   * The 'super' instance can be accessed
   * from `this.fastdom`.
   *
   * @example
   *
   * var myFastdom = fastdom.extend({
   *   initialize: function() {
   *     // runs on creation
   *   },
   *
   *   // override a method
   *   measure: function(fn) {
   *     // do extra stuff ...
   *
   *     // then call the original
   *     return this.fastdom.measure(fn);
   *   },
   *
   *   ...
   * });
   *
   * @param  {Object} props  properties to mixin
   * @return {FastDom}
   */
  extend: function(props) {
    debug('extend', props);
    if (typeof props != 'object') throw new Error('expected object');

    var child = Object.create(this);
    mixin(child, props);
    child.fastdom = this;

    // run optional creation hook
    if (child.initialize) child.initialize();

    return child;
  },

  // override this with a function
  // to prevent Errors in console
  // when tasks throw
  catch: null
};

/**
 * Schedules a new read/write
 * batch if one isn't pending.
 *
 * @private
 */
function scheduleFlush(fastdom) {
  if (!fastdom.scheduled) {
    fastdom.scheduled = true;
    fastdom.raf(flush.bind(null, fastdom));
    debug('flush scheduled');
  }
}

/**
 * Runs queued `read` and `write` tasks.
 *
 * Errors are caught and thrown by default.
 * If a `.catch` function has been defined
 * it is called instead.
 *
 * @private
 */
function flush(fastdom) {
  debug('flush');

  var writes = fastdom.writes;
  var reads = fastdom.reads;
  var error;

  try {
    debug('flushing reads', reads.length);
    runTasks(reads);
    debug('flushing writes', writes.length);
    runTasks(writes);
  } catch (e) { error = e; }

  fastdom.scheduled = false;

  // If the batch errored we may still have tasks queued
  if (reads.length || writes.length) scheduleFlush(fastdom);

  if (error) {
    debug('task errored', error.message);
    if (fastdom.catch) fastdom.catch(error);
    else throw error;
  }
}

/**
 * We run this inside a try catch
 * so that if any jobs error, we
 * are able to recover and continue
 * to flush the batch until it's empty.
 *
 * @private
 */
function runTasks(tasks) {
  debug('run tasks');
  var task; while (task = tasks.shift()) task();
}

/**
 * Remove an item from an Array.
 *
 * @param  {Array} array
 * @param  {*} item
 * @return {Boolean}
 */
function remove(array, item) {
  var index = array.indexOf(item);
  return !!~index && !!array.splice(index, 1);
}

/**
 * Mixin own properties of source
 * object into the target.
 *
 * @param  {Object} target
 * @param  {Object} source
 */
function mixin(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) target[key] = source[key];
  }
}

// There should never be more than
// one instance of `FastDom` in an app
var exports = win.fastdom = (win.fastdom || new FastDom()); // jshint ignore:line

// Expose to CJS & AMD
if (true) !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return exports; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
else if ((typeof module) == 'object') module.exports = exports;

})( typeof window !== 'undefined' ? window : this);


/***/ }),

/***/ "./node_modules/headroom.js/dist/headroom.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * headroom.js v0.9.4 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */

(function(root, factory) {
  'use strict';

  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  else if (typeof exports === 'object') {
    // COMMONJS
    module.exports = factory();
  }
  else {
    // BROWSER
    root.Headroom = factory();
  }
}(this, function() {
  'use strict';

  /* exported features */
  
  var features = {
    bind : !!(function(){}.bind),
    classList : 'classList' in document.documentElement,
    rAF : !!(window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame)
  };
  window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  
  /**
   * Handles debouncing of events via requestAnimationFrame
   * @see http://www.html5rocks.com/en/tutorials/speed/animations/
   * @param {Function} callback The callback to handle whichever event
   */
  function Debouncer (callback) {
    this.callback = callback;
    this.ticking = false;
  }
  Debouncer.prototype = {
    constructor : Debouncer,
  
    /**
     * dispatches the event to the supplied callback
     * @private
     */
    update : function() {
      this.callback && this.callback();
      this.ticking = false;
    },
  
    /**
     * ensures events don't get stacked
     * @private
     */
    requestTick : function() {
      if(!this.ticking) {
        requestAnimationFrame(this.rafCallback || (this.rafCallback = this.update.bind(this)));
        this.ticking = true;
      }
    },
  
    /**
     * Attach this as the event listeners
     */
    handleEvent : function() {
      this.requestTick();
    }
  };
  /**
   * Check if object is part of the DOM
   * @constructor
   * @param {Object} obj element to check
   */
  function isDOMElement(obj) {
    return obj && typeof window !== 'undefined' && (obj === window || obj.nodeType);
  }
  
  /**
   * Helper function for extending objects
   */
  function extend (object /*, objectN ... */) {
    if(arguments.length <= 0) {
      throw new Error('Missing arguments in extend function');
    }
  
    var result = object || {},
        key,
        i;
  
    for (i = 1; i < arguments.length; i++) {
      var replacement = arguments[i] || {};
  
      for (key in replacement) {
        // Recurse into object except if the object is a DOM element
        if(typeof result[key] === 'object' && ! isDOMElement(result[key])) {
          result[key] = extend(result[key], replacement[key]);
        }
        else {
          result[key] = result[key] || replacement[key];
        }
      }
    }
  
    return result;
  }
  
  /**
   * Helper function for normalizing tolerance option to object format
   */
  function normalizeTolerance (t) {
    return t === Object(t) ? t : { down : t, up : t };
  }
  
  /**
   * UI enhancement for fixed headers.
   * Hides header when scrolling down
   * Shows header when scrolling up
   * @constructor
   * @param {DOMElement} elem the header element
   * @param {Object} options options for the widget
   */
  function Headroom (elem, options) {
    options = extend(options, Headroom.options);
  
    this.lastKnownScrollY = 0;
    this.elem             = elem;
    this.tolerance        = normalizeTolerance(options.tolerance);
    this.classes          = options.classes;
    this.offset           = options.offset;
    this.scroller         = options.scroller;
    this.initialised      = false;
    this.onPin            = options.onPin;
    this.onUnpin          = options.onUnpin;
    this.onTop            = options.onTop;
    this.onNotTop         = options.onNotTop;
    this.onBottom         = options.onBottom;
    this.onNotBottom      = options.onNotBottom;
  }
  Headroom.prototype = {
    constructor : Headroom,
  
    /**
     * Initialises the widget
     */
    init : function() {
      if(!Headroom.cutsTheMustard) {
        return;
      }
  
      this.debouncer = new Debouncer(this.update.bind(this));
      this.elem.classList.add(this.classes.initial);
  
      // defer event registration to handle browser
      // potentially restoring previous scroll position
      setTimeout(this.attachEvent.bind(this), 100);
  
      return this;
    },
  
    /**
     * Unattaches events and removes any classes that were added
     */
    destroy : function() {
      var classes = this.classes;
  
      this.initialised = false;
  
      for (var key in classes) {
        if(classes.hasOwnProperty(key)) {
          this.elem.classList.remove(classes[key]);
        }
      }
  
      this.scroller.removeEventListener('scroll', this.debouncer, false);
    },
  
    /**
     * Attaches the scroll event
     * @private
     */
    attachEvent : function() {
      if(!this.initialised){
        this.lastKnownScrollY = this.getScrollY();
        this.initialised = true;
        this.scroller.addEventListener('scroll', this.debouncer, false);
  
        this.debouncer.handleEvent();
      }
    },
  
    /**
     * Unpins the header if it's currently pinned
     */
    unpin : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(classList.contains(classes.pinned) || !classList.contains(classes.unpinned)) {
        classList.add(classes.unpinned);
        classList.remove(classes.pinned);
        this.onUnpin && this.onUnpin.call(this);
      }
    },
  
    /**
     * Pins the header if it's currently unpinned
     */
    pin : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(classList.contains(classes.unpinned)) {
        classList.remove(classes.unpinned);
        classList.add(classes.pinned);
        this.onPin && this.onPin.call(this);
      }
    },
  
    /**
     * Handles the top states
     */
    top : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.top)) {
        classList.add(classes.top);
        classList.remove(classes.notTop);
        this.onTop && this.onTop.call(this);
      }
    },
  
    /**
     * Handles the not top state
     */
    notTop : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.notTop)) {
        classList.add(classes.notTop);
        classList.remove(classes.top);
        this.onNotTop && this.onNotTop.call(this);
      }
    },
  
    bottom : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.bottom)) {
        classList.add(classes.bottom);
        classList.remove(classes.notBottom);
        this.onBottom && this.onBottom.call(this);
      }
    },
  
    /**
     * Handles the not top state
     */
    notBottom : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.notBottom)) {
        classList.add(classes.notBottom);
        classList.remove(classes.bottom);
        this.onNotBottom && this.onNotBottom.call(this);
      }
    },
  
    /**
     * Gets the Y scroll position
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY
     * @return {Number} pixels the page has scrolled along the Y-axis
     */
    getScrollY : function() {
      return (this.scroller.pageYOffset !== undefined)
        ? this.scroller.pageYOffset
        : (this.scroller.scrollTop !== undefined)
          ? this.scroller.scrollTop
          : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    },
  
    /**
     * Gets the height of the viewport
     * @see http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
     * @return {int} the height of the viewport in pixels
     */
    getViewportHeight : function () {
      return window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
    },
  
    /**
     * Gets the physical height of the DOM element
     * @param  {Object}  elm the element to calculate the physical height of which
     * @return {int}     the physical height of the element in pixels
     */
    getElementPhysicalHeight : function (elm) {
      return Math.max(
        elm.offsetHeight,
        elm.clientHeight
      );
    },
  
    /**
     * Gets the physical height of the scroller element
     * @return {int} the physical height of the scroller element in pixels
     */
    getScrollerPhysicalHeight : function () {
      return (this.scroller === window || this.scroller === document.body)
        ? this.getViewportHeight()
        : this.getElementPhysicalHeight(this.scroller);
    },
  
    /**
     * Gets the height of the document
     * @see http://james.padolsey.com/javascript/get-document-height-cross-browser/
     * @return {int} the height of the document in pixels
     */
    getDocumentHeight : function () {
      var body = document.body,
        documentElement = document.documentElement;
  
      return Math.max(
        body.scrollHeight, documentElement.scrollHeight,
        body.offsetHeight, documentElement.offsetHeight,
        body.clientHeight, documentElement.clientHeight
      );
    },
  
    /**
     * Gets the height of the DOM element
     * @param  {Object}  elm the element to calculate the height of which
     * @return {int}     the height of the element in pixels
     */
    getElementHeight : function (elm) {
      return Math.max(
        elm.scrollHeight,
        elm.offsetHeight,
        elm.clientHeight
      );
    },
  
    /**
     * Gets the height of the scroller element
     * @return {int} the height of the scroller element in pixels
     */
    getScrollerHeight : function () {
      return (this.scroller === window || this.scroller === document.body)
        ? this.getDocumentHeight()
        : this.getElementHeight(this.scroller);
    },
  
    /**
     * determines if the scroll position is outside of document boundaries
     * @param  {int}  currentScrollY the current y scroll position
     * @return {bool} true if out of bounds, false otherwise
     */
    isOutOfBounds : function (currentScrollY) {
      var pastTop  = currentScrollY < 0,
        pastBottom = currentScrollY + this.getScrollerPhysicalHeight() > this.getScrollerHeight();
  
      return pastTop || pastBottom;
    },
  
    /**
     * determines if the tolerance has been exceeded
     * @param  {int} currentScrollY the current scroll y position
     * @return {bool} true if tolerance exceeded, false otherwise
     */
    toleranceExceeded : function (currentScrollY, direction) {
      return Math.abs(currentScrollY-this.lastKnownScrollY) >= this.tolerance[direction];
    },
  
    /**
     * determine if it is appropriate to unpin
     * @param  {int} currentScrollY the current y scroll position
     * @param  {bool} toleranceExceeded has the tolerance been exceeded?
     * @return {bool} true if should unpin, false otherwise
     */
    shouldUnpin : function (currentScrollY, toleranceExceeded) {
      var scrollingDown = currentScrollY > this.lastKnownScrollY,
        pastOffset = currentScrollY >= this.offset;
  
      return scrollingDown && pastOffset && toleranceExceeded;
    },
  
    /**
     * determine if it is appropriate to pin
     * @param  {int} currentScrollY the current y scroll position
     * @param  {bool} toleranceExceeded has the tolerance been exceeded?
     * @return {bool} true if should pin, false otherwise
     */
    shouldPin : function (currentScrollY, toleranceExceeded) {
      var scrollingUp  = currentScrollY < this.lastKnownScrollY,
        pastOffset = currentScrollY <= this.offset;
  
      return (scrollingUp && toleranceExceeded) || pastOffset;
    },
  
    /**
     * Handles updating the state of the widget
     */
    update : function() {
      var currentScrollY  = this.getScrollY(),
        scrollDirection = currentScrollY > this.lastKnownScrollY ? 'down' : 'up',
        toleranceExceeded = this.toleranceExceeded(currentScrollY, scrollDirection);
  
      if(this.isOutOfBounds(currentScrollY)) { // Ignore bouncy scrolling in OSX
        return;
      }
  
      if (currentScrollY <= this.offset ) {
        this.top();
      } else {
        this.notTop();
      }
  
      if(currentScrollY + this.getViewportHeight() >= this.getScrollerHeight()) {
        this.bottom();
      }
      else {
        this.notBottom();
      }
  
      if(this.shouldUnpin(currentScrollY, toleranceExceeded)) {
        this.unpin();
      }
      else if(this.shouldPin(currentScrollY, toleranceExceeded)) {
        this.pin();
      }
  
      this.lastKnownScrollY = currentScrollY;
    }
  };
  /**
   * Default options
   * @type {Object}
   */
  Headroom.options = {
    tolerance : {
      up : 0,
      down : 0
    },
    offset : 0,
    scroller: window,
    classes : {
      pinned : 'headroom--pinned',
      unpinned : 'headroom--unpinned',
      top : 'headroom--top',
      notTop : 'headroom--not-top',
      bottom : 'headroom--bottom',
      notBottom : 'headroom--not-bottom',
      initial : 'headroom'
    }
  };
  Headroom.cutsTheMustard = typeof features !== 'undefined' && features.rAF && features.bind && features.classList;

  return Headroom;
}));

/***/ }),

/***/ "./node_modules/js-component-framework/lib/Component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Internal, extendable class for instatianting components.
 * Each compoment should contain functionality for a single DOM element or selector.
 */
var Component = function () {

  /**
   * Create a component
   *
   * @param {object} config - Options for the component
   * @param {string} config.name - Name of component, used in data-component attribute for instantiation and key for instance manifest
   * @param {Class}  config.class - ES6 class instance (should extend this class)
   * @param {object} config.querySelector - children of component's element of which there are only one
   * @param {object} config.querySelectorAll - children of component's element of which there are many
   * @param {object} config.options - arbitrary object of additional options
   * @param {object} config.children - selectors (defined as strings) you can query manually in the component
   */
  function Component(config) {
    var _this = this;

    _classCallCheck(this, Component);

    this.element = config.element;
    this.started = false;
    this.name = config.name;

    // Peripheral configuration properties
    this.options = config.options || {};
    this.children = config.children || {};

    // Query all children of which there is only one
    if (config.querySelector) {
      Object.keys(config.querySelector).forEach(function (elementKey) {
        _this.children[elementKey] = _this.element.querySelector(config.querySelector[elementKey]);
      });
    }

    // Query all children of which there are many
    if (config.querySelectorAll) {
      Object.keys(config.querySelectorAll).forEach(function (elementKey) {
        _this.children[elementKey] = _this.element.querySelectorAll(config.querySelectorAll[elementKey]);
      });
    }
  }

  /**
   * Destroy the component, removing the element from the dom and all attached event handlers
   */


  _createClass(Component, [{
    key: "destroy",
    value: function destroy() {
      // remove instance element from DOM
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Get the top offset of an element relative to a specific DOM node.
     *
     * @param {HTMLElement} el - Element for which you need the offset
     * @param {HTMLElement} context - Element relative to which the offset should be calculcated
     */

  }, {
    key: "getOffsetTop",
    value: function getOffsetTop(el, context) {
      return context === el ? 0 : el.offsetTop + this.getOffsetTop(el.parentElement, context);
    }

    /**
     * Check whether a node is a descendant of another node
     *
     * @param {HTMLElement} el - Element to check
     * @param {HTMLElement} context - Parent element to check against
     */

  }], [{
    key: "isChild",
    value: function isChild(el, context) {
      if (el) {
        var node = el.parentNode;

        while (node) {
          if (node === context) {
            return true;
          }
          node = node.parentNode;
        }
      }

      return false;
    }
  }]);

  return Component;
}();

exports.default = Component;

/***/ }),

/***/ "./node_modules/js-component-framework/lib/ComponentManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Available to all components


var _Component = __webpack_require__("./node_modules/js-component-framework/lib/Component.js");

var _Component2 = _interopRequireDefault(_Component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__("./node_modules/core-js/modules/es6.object.assign.js");

/**
 * Internal class for instantiating the Module Manager
 */

var ComponentManager = function () {

  /**
   * Start the component manager
   *
   * @param {string} manifest - arbitrary string corresponding to an object on `window` that we'll use to track configuration and instances of each component.
   *                            This generally corresponds to the WP theme name (`wp-starter-theme` for example)
   */
  function ComponentManager(manifest) {
    _classCallCheck(this, ComponentManager);

    var manifestDefaults = { components: {} };

    window[manifest] = window[manifest] ? Object.assign({}, window[manifest], manifestDefaults) : manifestDefaults;

    this.manifest = window[manifest];
  }

  /**
   * Loop through component elements and instantiate the component for each
   *
   * @param {object|array} configs - config or configs corresponding to components you want to instance
   * @param {HTMLElement} context - context on which to initalize components, default is `document`
   */


  _createClass(ComponentManager, [{
    key: 'initComponents',
    value: function initComponents(configs) {
      var _this = this;

      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

      var componentConfigs = Array.isArray(configs) ? configs : [configs];

      componentConfigs.forEach(function (config) {
        var componentConfig = config;
        var componentName = componentConfig.name;
        var ComponentClass = componentConfig.class;

        // Check if component is configured and extends the core Component class
        if (ComponentClass.prototype instanceof _Component2.default) {
          var hasComponent = Object.prototype.hasOwnProperty.call(_this.manifest.components, componentName);
          var componentEls = context.querySelectorAll('[data-component=\'' + componentConfig.name + '\']');

          // Can't find any elements!
          if (!componentEls.length) {
            /* eslint-disable no-console, max-len */
            console.info('Component \'' + componentName + '\' does not exist or is configured incorrectly.\nCheck this component\'s config to ensure this component has a configuration object.\nAlso, verify the \'' + componentName + '\' class extends the core component class located in client/js/site/Component.js');
            /* eslint-enable */
            return;
          }

          // Add component to manifest if it doesn't exist already
          if (!hasComponent) {
            _this.manifest.components[componentName] = {
              config: componentConfig,
              instances: []
            };
          }

          // Loop through elements and add instance for each
          Array.prototype.forEach.call(componentEls, function (element) {
            // Skip this element if we've already instantiated a component on it
            var exists = _this.manifest.components[componentName].instances.some(function (instance) {
              return element === instance.element;
            });

            if (exists) {
              return;
            }

            // Create and start instance
            componentConfig.element = element;
            var instance = new ComponentClass(componentConfig);

            // add instance to manifest
            _this.manifest.components[componentName].instances.push({
              instance: instance,
              element: element
            });
          });
        }
      });
    }

    /**
     * Loop through and restart components (use, for example, if you've removed and re-added components from the DOM and need the JS started again)
     *
     * @param {string} componentName - name of component to instantiate
     * @param {HTMLElement} context - context on which to initalize components, default is entire document
     */

  }, {
    key: 'reinitComponent',
    value: function reinitComponent(componentName, context) {
      var componentConfig = this.manifest.components[componentName].config;

      if (componentConfig) {
        this.initComponents([componentConfig], context);
      }
    }

    /**
     * Call a method of a component from a different component
     *
     * @param {string} componentName - Name of component that has target function
     * @param {function} method - Component method you want to call
     * @param {array} args - Array of arguments to pass to component method
     */

  }], [{
    key: 'callComponentMethod',
    value: function callComponentMethod(componentName, method) {
      var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      // Does the component exist?
      if (this.mainfest[componentName] && this.mainfest[componentName].instances) {
        this.mainfest[componentName].instances.forEach(function (instance) {
          // Use JS .apply to call the component method with proper context
          if ('function' === typeof instance[method]) {
            var _instance$method;

            (_instance$method = instance[method]).call.apply(_instance$method, [instance].concat(_toConsumableArray(args)));
          }
        });
      }
    }
  }]);

  return ComponentManager;
}();

exports.default = ComponentManager;

/***/ }),

/***/ "./node_modules/js-component-framework/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plugins = exports.Component = exports.ComponentManager = undefined;

var _Component = __webpack_require__("./node_modules/js-component-framework/lib/Component.js");

var _Component2 = _interopRequireDefault(_Component);

var _ComponentManager = __webpack_require__("./node_modules/js-component-framework/lib/ComponentManager.js");

var _ComponentManager2 = _interopRequireDefault(_ComponentManager);

var _plugins = __webpack_require__("./node_modules/js-component-framework/lib/plugins/index.js");

var plugins = _interopRequireWildcard(_plugins);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ComponentManager = _ComponentManager2.default;
exports.Component = _Component2.default;
exports.plugins = plugins;

/***/ }),

/***/ "./node_modules/js-component-framework/lib/plugins/Aria.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Aria class.
 */
var Aria = function () {
  _createClass(Aria, null, [{
    key: 'eventPolyfill',

    /**
     * Polyfill CustomEvent.
     *
     * @static
     * @returns {Boolean}
     */
    value: function eventPolyfill() {
      if ('function' === typeof window.CustomEvent) {
        return false;
      }

      function CustomEvent(event) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          bubbles: false,
          cancelable: false,
          detail: undefined
        };

        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      }

      CustomEvent.prototype = window.Event.prototype;

      window.CustomEvent = CustomEvent;
      return true;
    }

    /**
     * Create a CustomEvent.
     *
     * @static
     * @param {String} type The type of the event.
     * @param {Object} detail Data to be passed with the event.
     * @returns {Object}
     */

  }, {
    key: 'createAriaEvent',
    value: function createAriaEvent(type) {
      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return new CustomEvent(type, {
        bubbles: true,
        cancelable: true,
        detail: detail
      });
    }

    /**
     * Check if an element is visible
     *
     * @static
     * @param {HTMLElement} element The element whose visibility is being checked
     * @returns {Boolean}
     */

  }, {
    key: 'isVisible',
    value: function isVisible(element) {
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }

    /**
     * Create an `id` attribute for the target element, based on a derpHash of the element's className.
     *
     * @returns {String}
     */

  }, {
    key: 'generateTargetId',
    value: function generateTargetId(element) {
      var targetClasses = element.className;
      // derpHash: Ensure a passably unique ID (but lets not go overboard)
      var derpHash = (Math.random() / targetClasses.length).toString(16).split('.')[1];
      return 'id_' + derpHash + '_' + targetClasses.split(' ').join('_');
    }
  }]);

  function Aria() {
    _classCallCheck(this, Aria);

    // eslint-disable-next-line max-len
    this.collectInteractiveChildren = this.collectInteractiveChildren.bind(this);
    this.setFocusToFirstItem = this.setFocusToFirstItem.bind(this);

    this.selectors = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'].join(',');

    this.tabKey = 9;
    this.escapeKey = 27;
  }

  /**
   * Collect all interactive child elements.
   */


  _createClass(Aria, [{
    key: 'collectInteractiveChildren',
    value: function collectInteractiveChildren() {
      var _this = this;

      if (undefined === this.targetElement) {
        // eslint-disable-next-line no-console
        console.error('No `targetElement` specified for collectInteractiveChildren');
        return;
      }

      var interactiveElements = this.targetElement.querySelectorAll(this.selectors);
      this.interactiveChildElements = Array.prototype.filter.call(interactiveElements, function (child) {
        return _this.constructor.isVisible(child);
      });
    }

    /**
     * Focus the dialog's first interactive child.
     */

  }, {
    key: 'setFocusToFirstItem',
    value: function setFocusToFirstItem() {
      if (this.interactiveChildElements.length) {
        this.interactiveChildElements[0].focus();
      }
    }
  }]);

  return Aria;
}();

exports.default = Aria;

/***/ }),

/***/ "./node_modules/js-component-framework/lib/plugins/AriaDialog.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fastdom = __webpack_require__("./node_modules/fastdom/fastdom.js");

var _fastdom2 = _interopRequireDefault(_fastdom);

var _Aria2 = __webpack_require__("./node_modules/js-component-framework/lib/plugins/Aria.js");

var _Aria3 = _interopRequireDefault(_Aria2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-underscore-dangle */


/**
 * Manage dialog (modal) elements
 *
 * @param {Object} config - Config options for AriaDialog
 * @param {HTMLElement} config.dialog - The dialog element
 * @param {HTMLElement} config.close - The dialog close button; should be the first child of the dialog
 * @param {Object} config.attributes - An Object of aria-* attributes to be added to the `target`, where the key completes an 'aria-' attribute name and the value is a valid attribute value.
 * @param {HTMLElement} config.content - The element wrapping the site content, of which the modal is NOT a child. The modal should be a child of document.body
 *
 * E.g.:
 * const modal = new AriaDialog({
 *   dialog: modalElement,
 *   close: closeElement,
 *   attributes: {
 *     label: 'Modal Title'
 *     labelledby: 'element-id'
 *     describedby: 'verbose-element-id'
 *   },
 *   content: siteWrapperElement
 * });
 */
var AriaDialog = function (_Aria) {
  _inherits(AriaDialog, _Aria);

  _createClass(AriaDialog, null, [{
    key: 'createOverlayElement',

    /**
     * Create the dialog overlay element.
     */
    value: function createOverlayElement() {
      var overlay = document.createElement('div');
      overlay.id = 'aria-dialog-overlay';
      return overlay;
    }
  }]);

  function AriaDialog(config) {
    _classCallCheck(this, AriaDialog);

    var _this = _possibleConstructorReturn(this, (AriaDialog.__proto__ || Object.getPrototypeOf(AriaDialog)).call(this));

    _this.element = config.dialog;
    _this.closeButton = config.close;
    _this.siteContent = config.content;
    _this.attributes = config.attributes || {};

    _this.targetElement = _this.element;

    _this.overlay = document.getElementById('aria-dialog-overlay');
    if (null === _this.overlay) {
      _this.overlay = _this.constructor.createOverlayElement();
      document.body.insertBefore(_this.overlay, _this.element);
    }

    _this.isShown = false;

    // Bind class methods
    _this.outsideClick = _this.outsideClick.bind(_this);
    _this.keyDownHandler = _this.keyDownHandler.bind(_this);
    _this.keydownTrapTab = _this.keydownTrapTab.bind(_this);
    _this.keydownEsc = _this.keydownEsc.bind(_this);
    _this._hide = _this._hide.bind(_this);
    _this._show = _this._show.bind(_this);
    _this.ariaHide = _this.ariaHide.bind(_this);
    _this.ariaShow = _this.ariaShow.bind(_this);
    _this.ariaToggle = _this.ariaToggle.bind(_this);

    _Aria3.default.eventPolyfill();
    _this.init();
    return _this;
  }

  /**
   * Initial element setup.
   */


  _createClass(AriaDialog, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      this.element.setAttribute('aria-hidden', 'true');

      Object.keys(this.attributes).forEach(function (attr) {
        _this2.element.setAttribute('aria-' + attr, _this2.attributes[attr]);
      });
    }

    /**
     * Close the dialog on outside click.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'outsideClick',
    value: function outsideClick(event) {
      if (this.isShown && !this.element.contains(event.target)) {
        this.ariaHide();
      }
    }

    /**
     * Handle key presses.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'keyDownHandler',
    value: function keyDownHandler(event) {
      if (this.isShown) {
        if (event.keyCode === this.tabKey) {
          this.keydownTrapTab(event);
        } else if (event.keyCode === this.escapeKey) {
          this.keydownEsc();
        }
      }
    }

    /**
     * Trap key tabs inside dialog.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'keydownTrapTab',
    value: function keydownTrapTab(event) {
      this.collectInteractiveChildren();
      var focusedIndex = Array.prototype.indexOf.call(this.interactiveChildElements, document.activeElement);

      var lastItem = this.interactiveChildElements.length - 1;

      if (event.shiftKey && 0 === focusedIndex) {
        event.preventDefault();
        this.interactiveChildElements[lastItem].focus();
      } else if (!event.shiftKey && focusedIndex === lastItem) {
        // eslint-disable-line max-len
        event.preventDefault();
        this.interactiveChildElements[0].focus();
      }
    }

    /**
     * Close the dialog on ESC key press.
     */

  }, {
    key: 'keydownEsc',
    value: function keydownEsc() {
      this.ariaHide();
    }

    /**
     * Externally-exposed hide method
     */

  }, {
    key: 'ariaHide',
    value: function ariaHide() {
      _fastdom2.default.mutate(this._hide);
    }

    /**
     * ARIA-hide the target element.
     *
     * @private
     */

  }, {
    key: '_hide',
    value: function _hide() {
      this.element.setAttribute('aria-hidden', 'true');
      this.siteContent.setAttribute('aria-hidden', 'false');

      this.isShown = false;

      this.closeButton.removeEventListener('click', this.ariaHide);
      document.body.removeEventListener('keydown', this.keyDownHandler);
      this.overlay.removeEventListener('click', this.outsideClick);

      var hide = null;
      var detail = { expanded: this.isShown };
      hide = _Aria3.default.createAriaEvent('dialoghide', detail);
      this.element.dispatchEvent(hide);

      this.focusEl.focus();
    }

    /**
     * Externally-exposed hide method
     */

  }, {
    key: 'ariaShow',
    value: function ariaShow() {
      _fastdom2.default.mutate(this._show);
    }

    /**
     * ARIA-show the target element.
     *
     * @private
     */

  }, {
    key: '_show',
    value: function _show() {
      this.focusEl = document.activeElement;
      this.element.setAttribute('aria-hidden', 'false');
      this.siteContent.setAttribute('aria-hidden', 'true');

      this.isShown = true;

      this.closeButton.addEventListener('click', this.ariaHide);
      document.body.addEventListener('keydown', this.keyDownHandler);
      this.overlay.addEventListener('click', this.outsideClick);

      var show = null;
      var detail = { expanded: this.isShown };
      show = _Aria3.default.createAriaEvent('dialogshow', detail);
      this.element.dispatchEvent(show);

      this.collectInteractiveChildren();
      this.setFocusToFirstItem();
    }

    /**
     * Toggle ARIA attributes.
     */

  }, {
    key: 'ariaToggle',
    value: function ariaToggle() {
      if (this.isShown) {
        this.ariaHide();
      } else {
        this.ariaShow();
      }
    }
  }]);

  return AriaDialog;
}(_Aria3.default);

exports.default = AriaDialog;

/***/ }),

/***/ "./node_modules/js-component-framework/lib/plugins/AriaPopup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fastdom = __webpack_require__("./node_modules/fastdom/fastdom.js");

var _fastdom2 = _interopRequireDefault(_fastdom);

var _Aria2 = __webpack_require__("./node_modules/js-component-framework/lib/plugins/Aria.js");

var _Aria3 = _interopRequireDefault(_Aria2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-underscore-dangle */


/**
 * Manage aria-haspopup elements
 *
 * @param {Object} config - Config options for AriaPopup
 * @param {HTMLElement} config.controller - The controlling element
 * @param {HTMLElement} config.target - The element controlled by `controller`
 * @param {Object} config.attributes - An Object of aria-* attributes to be added to the `target`, where the key completes an 'aria-' attribute name and the value is a valid attribute value.
 *
 * E.g.:
 * const popup = new AriaPopup({
 *   controller: controllingButton,
 *   target: targetElement,
 *   attributes: {
 *     label: 'submenu'
 *     labelledby: 'element-id'
 *     describedby: 'verbose-element-id'
 *   }
 * });
 */
var AriaPopup = function (_Aria) {
  _inherits(AriaPopup, _Aria);

  function AriaPopup(config) {
    _classCallCheck(this, AriaPopup);

    var _this = _possibleConstructorReturn(this, (AriaPopup.__proto__ || Object.getPrototypeOf(AriaPopup)).call(this));

    _this.controller = config.controller;
    _this.target = config.target;
    _this.attributes = config.attributes || {};

    _this.targetElement = _this.target;

    _this.targetAttr = {};
    _this.isExpanded = false;

    // Bind class methods
    _this.setTargetAttributes = _this.setTargetAttributes.bind(_this);
    _this.rovingTabIndex = _this.rovingTabIndex.bind(_this);
    _this.outsideClick = _this.outsideClick.bind(_this);
    _this.keyDownHandler = _this.keyDownHandler.bind(_this);
    _this.keydownTabOut = _this.keydownTabOut.bind(_this);
    _this.keydownEsc = _this.keydownEsc.bind(_this);
    _this.ariaSetup = _this.ariaSetup.bind(_this);
    _this._hide = _this._hide.bind(_this);
    _this._show = _this._show.bind(_this);
    _this._destroy = _this._destroy.bind(_this);
    _this._reset = _this._reset.bind(_this);
    _this.ariaHide = _this.ariaHide.bind(_this);
    _this.ariaShow = _this.ariaShow.bind(_this);
    _this.ariaToggle = _this.ariaToggle.bind(_this);
    _this.ariaDestroy = _this.ariaDestroy.bind(_this);
    _this.ariaReset = _this.ariaReset.bind(_this);

    _this.collectInteractiveChildren();
    _this.setTargetAttributes();
    _Aria3.default.eventPolyfill();
    _this.ariaSetup();
    return _this;
  }

  /**
   * Add initial attributes, establish relationships, and listen for events
   */


  _createClass(AriaPopup, [{
    key: 'ariaSetup',
    value: function ariaSetup() {
      var _this2 = this;

      this.controller.setAttribute('aria-haspopup', 'true');
      this.controller.setAttribute('aria-expanded', 'false');
      this.controller.setAttribute('aria-controls', this.targetId);

      if (this.target !== this.controller.nextElementSibling) {
        this.controller.setAttribute('aria-owns', this.targetId);
      }

      this.target.setAttribute('aria-hidden', 'true');

      Object.keys(this.targetAttr).forEach(function (attr) {
        _this2.target.setAttribute(attr, _this2.targetAttr[attr]);
      });

      this.rovingTabIndex();

      this.controller.addEventListener('click', this.ariaToggle);
      this.target.addEventListener('keydown', this.keyDownHandler);
      document.body.addEventListener('click', this.outsideClick);
    }

    /**
     * Copy attributes over as their full attribute name.
     */

  }, {
    key: 'setTargetAttributes',
    value: function setTargetAttributes() {
      var _this3 = this;

      if ('object' === _typeof(this.attributes)) {
        Object.keys(this.attributes).forEach(function (prop) {
          _this3.targetAttr['aria-' + prop] = _this3.attributes[prop];
        });
      }

      // Configure a target element ID if it doesn't exist.
      if ('' !== this.target.id) {
        this.targetId = this.target.id;
      } else {
        this.targetId = _Aria3.default.generateTargetId(this.target);
        this.target.id = this.targetId;
      }
    }

    /**
     * Close the dialog on outside click.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'outsideClick',
    value: function outsideClick(event) {
      if (this.isExpanded && !this.controller.contains(event.target) && !this.target.contains(event.target)) {
        this.ariaHide();
      }
    }

    /**
     * Handle key presses.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'keyDownHandler',
    value: function keyDownHandler(event) {
      if (this.isExpanded) {
        if (event.keyCode === this.tabKey) {
          this.keydownTabOut(event);
        } else if (event.keyCode === this.escapeKey) {
          event.stopPropagation();
          this.keydownEsc();
        }
      }
    }

    /**
     * Close the dialog on ESC key press.
     */

  }, {
    key: 'keydownEsc',
    value: function keydownEsc() {
      this.ariaHide();
    }

    /**
     * Close submenu on tab-out.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'keydownTabOut',
    value: function keydownTabOut(event) {
      var focusedIndex = Array.prototype.indexOf.call(this.interactiveChildElements, document.activeElement);

      if (event.shiftKey && 0 === focusedIndex) {
        event.preventDefault();
        this.ariaHide();
      } else if (!event.shiftKey && focusedIndex === this.interactiveChildElements.length - 1) {
        this.ariaHide();
      }
    }

    /**
     * Prevent hidden menu items from having focus.
     */

  }, {
    key: 'rovingTabIndex',
    value: function rovingTabIndex() {
      var _this4 = this;

      this.collectInteractiveChildren();

      Array.prototype.forEach.call(this.interactiveChildElements, function (child) {
        if (_this4.isExpanded) {
          child.removeAttribute('tabindex');
        } else {
          child.setAttribute('tabindex', '-1');
        }
      });
    }

    /**
     * Externally-exposed hide method
     */

  }, {
    key: 'ariaHide',
    value: function ariaHide() {
      _fastdom2.default.mutate(this._hide);
    }

    /**
     * ARIA-hide the target element.
     *
     * @private
     */

  }, {
    key: '_hide',
    value: function _hide() {
      if (this.target.contains(document.activeElement)) {
        this.controller.focus();
      }

      this.controller.setAttribute('aria-expanded', 'false');
      this.target.setAttribute('aria-hidden', 'true');

      this.isExpanded = false;

      var hide = null;
      var detail = { expanded: this.isExpanded };
      hide = _Aria3.default.createAriaEvent('popuphide', detail);
      this.controller.dispatchEvent(hide);

      this.rovingTabIndex();
    }

    /**
     * Externally-exposed show method
     */

  }, {
    key: 'ariaShow',
    value: function ariaShow() {
      _fastdom2.default.mutate(this._show);
    }

    /**
     * ARIA-show the target element.
     *
     * @private
     */

  }, {
    key: '_show',
    value: function _show() {
      this.controller.setAttribute('aria-expanded', 'true');
      this.target.setAttribute('aria-hidden', 'false');

      this.isExpanded = true;

      var show = null;
      var detail = { expanded: this.isExpanded };
      show = _Aria3.default.createAriaEvent('popupshow', detail);
      this.controller.dispatchEvent(show);

      this.collectInteractiveChildren();
      this.rovingTabIndex();
      this.setFocusToFirstItem();
    }

    /**
     * Toggle ARIA attributes.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'ariaToggle',
    value: function ariaToggle(event) {
      event.preventDefault();
      if (this.isExpanded) {
        this.ariaHide();
      } else {
        this.ariaShow();
      }
    }

    /**
     * Externally-exposed destroy method
     */

  }, {
    key: 'ariaDestroy',
    value: function ariaDestroy() {
      _fastdom2.default.mutate(this._destroy);
    }

    /**
     * Remove all ARIA attributes added by this class.
     *
     * @private
     */

  }, {
    key: '_destroy',
    value: function _destroy() {
      var _this5 = this;

      if (this.target.contains(document.activeElement)) {
        this.controller.focus();
      }

      this.controller.removeAttribute('aria-haspopup');
      this.controller.removeAttribute('aria-expanded');
      this.controller.removeAttribute('aria-controls');
      this.controller.removeAttribute('aria-owns');

      this.target.removeAttribute('aria-hidden');

      Object.keys(this.targetAttr).forEach(function (attr) {
        _this5.target.removeAttribute(attr, _this5.targetAttr[attr]);
      });

      this.isExpanded = false;

      this.collectInteractiveChildren();

      Array.prototype.forEach.call(this.interactiveChildElements, function (child) {
        child.removeAttribute('tabindex');
      });

      var destroy = null;
      var detail = { expanded: this.isExpanded };
      destroy = _Aria3.default.createAriaEvent('popupdestroy', detail);
      this.controller.dispatchEvent(destroy);
    }

    /**
     * Externally-exposed reset method
     */

  }, {
    key: 'ariaReset',
    value: function ariaReset() {
      _fastdom2.default.mutate(this._reset);
    }

    /**
     * Reset ARIA attributes.
     *
     * @private
     */

  }, {
    key: '_reset',
    value: function _reset() {
      this.ariaSetup();

      if (this.target.contains(document.activeElement)) {
        this.controller.focus();
      }

      var reset = null;
      var detail = { expanded: false };
      reset = _Aria3.default.createAriaEvent('popupreset', detail);
      this.controller.dispatchEvent(reset);
    }
  }]);

  return AriaPopup;
}(_Aria3.default);

exports.default = AriaPopup;

/***/ }),

/***/ "./node_modules/js-component-framework/lib/plugins/AriaTablist.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fastdom = __webpack_require__("./node_modules/fastdom/fastdom.js");

var _fastdom2 = _interopRequireDefault(_fastdom);

var _Aria2 = __webpack_require__("./node_modules/js-component-framework/lib/plugins/Aria.js");

var _Aria3 = _interopRequireDefault(_Aria2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-underscore-dangle */


/**
 * Manage tablist elements
 *
 * @param {Object} config - Config options for AriaTablist
 * @param {HTMLElement} config.tablist - The tab elements' parent element
 * @param {NodeList} config.panels - A list of panel elements; each panel should have a corresponding tab element in config.tabs
 * @param {MediaQueryList} config.breakpoint - An optional breakpoint definition to be used to init and/or destroy the tablist
 *
 * E.g.:
 * const tablist = new AriaTablist({
 *   tablist: tabsWrapper,
 *   panels: panelElements,
 *   breakpoint: mediaQuery
 * });
 */
var AriaTablist = function (_Aria) {
  _inherits(AriaTablist, _Aria);

  function AriaTablist(config) {
    _classCallCheck(this, AriaTablist);

    var _this = _possibleConstructorReturn(this, (AriaTablist.__proto__ || Object.getPrototypeOf(AriaTablist)).call(this));

    _this.tablist = config.tablist;
    _this.panels = config.panels;
    _this.breakpoint = config.breakpoint;

    _this.index = 0;

    _this.key = {
      arrows: /37|39|40/, // left, right, or down
      arrLeftRight: /37|39/,
      arrLeft: 37,
      arrRight: 39,
      arrDown: 40
    };

    _this.tabs = [];
    _this.panels = Array.prototype.slice.call(_this.panels);

    Array.prototype.forEach.call(_this.tablist.children, function (child) {
      if ('LI' === child.nodeName) {
        child.setAttribute('role', 'presentation');
        var childAnchor = child.querySelector('a[href]');
        _this.tabs.push(childAnchor);
      } else {
        _this.tabs.push(child);
      }
    });

    // Bind class methods
    _this.shiftTabKeyDown = _this.shiftTabKeyDown.bind(_this);
    _this.keyDownHandler = _this.keyDownHandler.bind(_this);
    _this.arrowKeyDown = _this.arrowKeyDown.bind(_this);
    _this.tabKeyDown = _this.tabKeyDown.bind(_this);
    _this.ariaSwitchTab = _this.ariaSwitchTab.bind(_this);
    _this._updateTabs = _this._updateTabs.bind(_this);
    _this.updateTabs = _this.updateTabs.bind(_this);
    _this.handleBreakpoint = _this.handleBreakpoint.bind(_this);
    _this.tearDown = _this.tearDown.bind(_this);

    _Aria3.default.eventPolyfill();

    if (undefined === _this.breakpoint || 'object' !== _typeof(_this.breakpoint)) {
      _this.init();
    } else {
      _this.handleBreakpoint();
      _this.breakpoint.addListener(_this.handleBreakpoint);
    }
    return _this;
  }

  /**
   * Add necessary attributes and event listeners; collect interactive elements.
   */


  _createClass(AriaTablist, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      this.tablist.setAttribute('role', 'tablist');

      // role=tab, aria-selected
      this.tabs.forEach(function (tab, index) {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', '' + (_this2.index === index));
        if (_this2.index === index) {
          tab.setAttribute('tabindex', '0');
        } else {
          tab.setAttribute('tabindex', '-1');
        }

        tab.addEventListener('click', _this2.ariaSwitchTab);
        tab.addEventListener('keydown', _this2.keyDownHandler);
      });

      // role=tabpanel, aria-labelledby, aria-hidden
      this.panels.forEach(function (panel, index) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-hidden', '' + (_this2.index !== index));
      });

      this.targetElement = this.panels[this.index];
      this.collectInteractiveChildren();

      this.panels[this.index].addEventListener('keydown', this.shiftTabKeyDown);

      var tabInit = null;
      var detail = { activePanel: this.panels[this.index] };
      tabInit = _Aria3.default.createAriaEvent('tabinit', detail);
      this.tablist.dispatchEvent(tabInit);
    }

    /**
     * TAB from the active panel's first focusable element back to the active tab.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'shiftTabKeyDown',
    value: function shiftTabKeyDown(event) {
      if (event.keyCode === this.tabKey && event.shiftKey) {
        var focusIndex = this.interactiveChildElements.indexOf(document.activeElement);

        if (0 === focusIndex) {
          var currentPanel = this.panels.filter(function (panel) {
            return 'false' === panel.getAttribute('aria-hidden');
          });
          var panelIndex = this.panels.indexOf(currentPanel[0]);

          event.preventDefault();
          this.tabs[panelIndex].focus();
        }
      }
    }

    /**
     * Handle tablist key presses.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'keyDownHandler',
    value: function keyDownHandler(event) {
      if (event.keyCode === this.tabKey && !event.shiftKey) {
        this.tabKeyDown(event);
      } else if (this.key.arrows.test(event.keyCode)) {
        this.arrowKeyDown(event);
      }
    }

    /**
     * Move focus from active tab to active panel's first child.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'tabKeyDown',
    value: function tabKeyDown(event) {
      if (this.interactiveChildElements.length) {
        event.preventDefault();
        this.interactiveChildElements[0].focus();
      }
    }

    /**
     * Navigate through tablist with arrow keys.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'arrowKeyDown',
    value: function arrowKeyDown(event) {
      var newIndex = null;
      var deactivate = {};
      var activate = {};

      var currentIndex = this.tabs.indexOf(event.currentTarget);
      deactivate.tab = this.tabs[currentIndex];
      deactivate.panel = this.panels[currentIndex];

      this.panels.forEach(function (panel) {
        panel.removeAttribute('tabindex');
      });

      if (this.key.arrLeftRight.test(event.keyCode)) {
        switch (event.keyCode) {
          case this.key.arrLeft:
            newIndex = currentIndex - 1;
            break;
          case this.key.arrRight:
            newIndex = currentIndex + 1;
            break;
          default:
            newIndex = null;
        }
        event.preventDefault();

        activate.index = newIndex;
        activate.tab = this.tabs[newIndex];
        activate.panel = this.panels[newIndex];

        this.updateTabs(deactivate, activate);
        activate.tab.focus();
      } else if (event.keyCode === this.key.arrDown) {
        event.preventDefault();
        this.panels[currentIndex].setAttribute('tabindex', '-1');
        this.panels[currentIndex].focus();
      }
    }

    /**
     * Externally-exposed tab updater method
     */

  }, {
    key: 'updateTabs',
    value: function updateTabs(deactivate, activate) {
      var _this3 = this;

      _fastdom2.default.mutate(function () {
        _this3._updateTabs(deactivate, activate);
      });
    }

    /**
     * Toggle active panel based on active tab.
     *
     * @param {Object} deactivate
     * @param {HTMLElement} deactivate.tab The tab item to deactivate.
     * @param {HTMLElement} deactivate.panel The panel to deactivate.
     * @param {Object} activate
     * @param {HTMLElement} activate.tab The tab item to activate.
     * @param {HTMLElement} activate.panel The panel to activate.
     * @private
     */

  }, {
    key: '_updateTabs',
    value: function _updateTabs(deactivate, activate) {
      var selected = 'false';
      var hidden = 'true';

      if (null !== deactivate.tab || null !== activate.tab || null !== deactivate.panel || null !== activate.panel) {
        // Update current tab
        deactivate.tab.setAttribute('tabindex', '-1');
        deactivate.tab.setAttribute('aria-selected', selected);
        deactivate.panel.setAttribute('aria-hidden', hidden);

        this.targetElement = deactivate.panel;
        this.collectInteractiveChildren();

        Array.prototype.forEach.call(this.interactiveChildElements, function (focusElement) {
          focusElement.setAttribute('tabindex', '-1');
        });

        deactivate.panel.removeEventListener('keydown', this.shiftTabKeyDown);

        // Update new active tab
        var _ref = [hidden, selected];
        selected = _ref[0];
        hidden = _ref[1];

        activate.tab.setAttribute('tabindex', '0');
        activate.tab.setAttribute('aria-selected', selected);
        activate.panel.setAttribute('aria-hidden', hidden);

        this.targetElement = activate.panel;
        this.collectInteractiveChildren();

        Array.prototype.forEach.call(this.interactiveChildElements, function (element) {
          if ('-1' === element.getAttribute('tabindex')) {
            element.removeAttribute('tabindex');
          }
        });

        this.index = activate.index;

        activate.panel.addEventListener('keydown', this.shiftTabKeyDown);

        var tabChange = null;
        var detail = { activePanel: this.panels[this.index] };
        tabChange = _Aria3.default.createAriaEvent('tabchange', detail);
        this.tablist.dispatchEvent(tabChange);
      }
    }

    /**
     * Collect tab and panel info then toggle tabs/panels.
     *
     * @param {Object} event The event object.
     */

  }, {
    key: 'ariaSwitchTab',
    value: function ariaSwitchTab(event) {
      var deactivate = {};
      var activate = {};

      event.preventDefault();

      if ('true' !== event.target.getAttribute('aria-selected')) {
        deactivate.tab = this.tablist.querySelector('[aria-selected="true"]');
        var currentTablistIndex = this.tabs.indexOf(deactivate.tab);
        deactivate.panel = this.panels[currentTablistIndex];

        activate.index = this.tabs.indexOf(event.target);
        activate.tab = this.tabs[activate.index];
        activate.panel = this.panels[activate.index];

        this.updateTabs(deactivate, activate);
      }
    }

    /**
     * Destroy the tablist, removing ARIA attributes and event listeners
     */

  }, {
    key: 'tearDown',
    value: function tearDown() {
      var _this4 = this;

      this.tablist.removeAttribute('role');

      this.tabs.forEach(function (tab, index) {
        tab.removeAttribute('role');
        tab.removeAttribute('aria-selected');
        if (_this4.index !== index) {
          tab.removeAttribute('tabindex');
        }

        tab.removeEventListener('click', _this4.ariaSwitchTab);
        tab.removeEventListener('keydown', _this4.keyDownHandler);
      });

      this.panels.forEach(function (panel) {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-hidden');
      });

      this.targetElement = this.panels[this.index];
      this.collectInteractiveChildren();

      this.panels[this.index].removeEventListener('keydown', this.shiftTabKeyDown);

      var detail = { activePanel: null };
      var tablistTeardown = _Aria3.default.createAriaEvent('tablistTeardown', detail);
      this.tablist.dispatchEvent(tablistTeardown);
    }

    /**
     * Handle breakpoint changes as necessary.
     */

  }, {
    key: 'handleBreakpoint',
    value: function handleBreakpoint() {
      if (this.breakpoint.matches) {
        this.init();
      } else {
        this.tearDown();
      }
    }
  }]);

  return AriaTablist;
}(_Aria3.default);

exports.default = AriaTablist;

/***/ }),

/***/ "./node_modules/js-component-framework/lib/plugins/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AriaDialog = exports.AriaPopup = exports.AriaTablist = exports.Aria = undefined;

var _Aria = __webpack_require__("./node_modules/js-component-framework/lib/plugins/Aria.js");

var _Aria2 = _interopRequireDefault(_Aria);

var _AriaTablist = __webpack_require__("./node_modules/js-component-framework/lib/plugins/AriaTablist.js");

var _AriaTablist2 = _interopRequireDefault(_AriaTablist);

var _AriaPopup = __webpack_require__("./node_modules/js-component-framework/lib/plugins/AriaPopup.js");

var _AriaPopup2 = _interopRequireDefault(_AriaPopup);

var _AriaDialog = __webpack_require__("./node_modules/js-component-framework/lib/plugins/AriaDialog.js");

var _AriaDialog2 = _interopRequireDefault(_AriaDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Aria = _Aria2.default;
exports.AriaTablist = _AriaTablist2.default;
exports.AriaPopup = _AriaPopup2.default;
exports.AriaDialog = _AriaDialog2.default;

/***/ }),

/***/ "./node_modules/style-loader/addStyles.js":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ })

/******/ });


// WEBPACK FOOTER //
// js/common.46d7bf5.bundle.min.js